<section>
    <h1>Implementations</h1>
    <div style="display: flex; gap: .25em">
        <div>
            <img width src="./images/qr-py.png" alt="python qr code" />
            <a href="https://github.com/kix2mix2/Hagrid">Python</a>
        </div>
        <div>
            <img src="./images/qr-js.png" alt="js qr code" />
            <a href="https://github.com/saehm/hagrid">JavaScript</a>
        </div>
    </div>
    <aside class="notes">
        There are two implementations of Hagrid, one in Python and one in JavaScript.
        We did the evaluation with the Python implementation, and this presentation, for example, was made with the JavaScript hagrid library.
    </aside>
</section>

<section>
    <h1>Thank you</h1>
    <img src="images/teaser_image.png" alt="teaser" />
    <h5>Rene Cutura ❖ Cristina Morariu ❖ Zhanglin Cheng ❖ Yunhai Wang ❖ Daniel Weiskopf ❖ Michael Sedlmair</h5>
    <aside class="notes">
        Thank you :-)
    </aside>
</section>